import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

import { getFirestoreDb } from '../config/firebaseApp';

const COL = 'support_messages';

export async function submitSupportMessage(input: {
  userId: string;
  message: string;
  displayNameSnapshot?: string;
}): Promise<void> {
  const text = input.message.trim();
  if (text.length < 10) {
    throw new Error('Mesaj en az 10 karakter olsun.');
  }
  if (text.length > 4000) {
    throw new Error('Mesaj en fazla 4000 karakter olabilir.');
  }
  const name = (input.displayNameSnapshot ?? '').trim().slice(0, 120);
  await addDoc(collection(getFirestoreDb(), COL), {
    userId: input.userId,
    message: text,
    ...(name ? { displayNameSnapshot: name } : {}),
    createdAt: serverTimestamp(),
  });
}
